import type { UseStore } from 'idb-keyval';
import { clear, createStore, entries, set } from 'idb-keyval';
import type { MutableRefObject } from 'react';
import type { PortCostData, PortCostPair, MarcuraPortCosts } from './context';
import { PortCostMap } from './portCostMap';
import type { ScenarioLocation } from '../../lib/planningData';
import type { Assortment_AdminFragment } from '../../graphql';
import type { LocationId } from '@seaber/common/core/entries';

let store: UseStore;

export const generateIdbKey = (pair: PortCostPair) => {
  return `${pair[0]}_${pair[1]}`;
};

export function getPortCostIdb(): UseStore {
  // Update version if we need to clear the browser cache for users
  if (!store) store = createStore('marcura-port-cost-cache-1', 'keyval');
  return store;
}

export async function clearPortCostCache(): Promise<void> {
  return await clear(getPortCostIdb());
}

export const getStoredPortCosts = async (
  portCosts: MutableRefObject<MarcuraPortCosts>,
  locationsById: Map<LocationId, ScenarioLocation>,
  assortmentsById: Map<number, Assortment_AdminFragment>,
): Promise<MarcuraPortCosts> => {
  const portCostEntries = await entries(getPortCostIdb());
  const storedPortCosts = new PortCostMap(
    portCosts.current.map,
    locationsById,
    assortmentsById,
  );
  const map = storedPortCosts.map;

  for (const [key, value] of portCostEntries) {
    if (!value || !key) continue;

    const [portExternalId, assortmentGroupExternalId] = key
      .toString()
      .split('_');

    try {
      map.set(value, portExternalId, assortmentGroupExternalId);
    } catch (err) {
      console.error('port cost parsing failed', err);
    }
  }

  return storedPortCosts;
};

export const setStoredPortCost = (data: PortCostData) => {
  const idbKey = `${data.marcura_port_id}_${data.marcura_group_id}`;
  if (idbKey) {
    void set(idbKey, data, getPortCostIdb());
  }
};
